import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  paper: {
    overflow: 'hidden',
    backgroundColor: '#FFF',
    border: '1px solid #E5E5E5',
    boxSizing: 'border-box',
    borderRadius: '3px',
    width: '1000px',
    maxWidth: '1000px',
    minHeight: '700px',
    height: '700px',
    margin: '25px',
    ['@media (max-width:960px)']: {
      height: '100%',
      maxHeight: '100%',
      minHeight: '100%',
      width: '100%',
      margin: 0
    }
  },
  form: {
    height: '100%'
  },
  content: {
    padding: '0 40px',
    margin: '0 0 48px',
    overflow: 'auto',
    height: 'calc(100% - 111px)',
    ['@media (max-width:600px)']: {
      padding: '0 15px',
      height: 'calc(100% - 150px)'
    }
  },
  title: {
    margin: '10px 0 15px'
  },
  editSection: {
    display: 'flex',
    margin: '0 0 30px',
    ['@media (max-width:1010px)']: {
      flexDirection: 'column',
      margin: '0 0 5px'
    }
  },
  editItem: {
    padding: '0 0 0 40px',
    '&:first-child': {
      borderRight: '1px solid #e2ebf6',
      padding: '0 40px 0 0'
    },
    '&:last-child': {
      width: '100%'
    },
    ['@media (max-width:1010px)']: {
      border: 0,
      padding: 0,
      margin: 0,
      maxWidth: '100%',
      '&:first-child': {
        border: 0,
        padding: 0
      }
    }
  },
  item: {
    width: '100%',
    maxWidth: '540px',
    padding: '0 30px 0 0',
    margin: '0 30px 0 0',
    borderRight: '1px solid #e2ebf6',
    '&:last-child': {
      border: 0,
      padding: 0,
      margin: 0
    },
    ['@media (max-width:1010px)']: {
      border: 0,
      padding: 0,
      margin: 0,
      maxWidth: '100%'
    }
  },
  date: {
    width: '313px',
    minWidth: '313px',
    ['@media (max-width:1010px)']: {
      width: '606px'
    },
    ['@media (max-width:750px)']: {
      width: '313px'
    },
    ['@media (max-width:600px)']: {
      width: '333px'
    }
  },
  rangeDates: {
    ['@media (max-width:1010px)']: {
      width: '606px'
    },
    ['@media (max-width:750px)']: {
      width: '313px'
    },
    ['@media (max-width:600px)']: {
      width: '333px'
    }
  },
  availabilityTitle: {
    margin: '0 0 10px',
    textTransform: 'uppercase',
    letterSpacing: '0.05em'
  },
  availabilityLabel: {
    fontSize: '14px'
  },
  radioGroupRoot: {
    flexDirection: 'column'
  },
  loaderClassName: {
    width: '80px !important',
    height: '80px !important'
  },
  disableInputFocus: {
    display: 'none'
  },
  visitItem: {
    flex: '0 0 100%',
    '&:last-child': {
      border: 0
    }
  },
  visitTitleClass: {
    fontSize: '14px'
  },
  label: {
    textTransform: 'uppercase',
    letterSpacing: '0.05em'
  },
  visitorsWrapperClass: {
    ['@media (max-width:1010px)']: {
      paddingBottom: '10px'
    }
  },
  sectionTitleIndent: {
    marginBottom: '20px',
    textTransform: 'uppercase',
    letterSpacing: '0.05em'
  },
  addOnWrapperClass: {
    marginBottom: '30px'
  },
  addOnItemClass: {
    '&:last-child': {
      borderBottom: 0
    }
  },
  addOnDescClass: {
    width: '100%',
    marginRight: '10px'
  },
  location: {
    display: 'flex',
    alignItems: 'end',
    marginBottom: '20px',
    marginLeft: '-5px'
  },
  locationIcon: {
    fontSize: '20px',
    marginRight: '10px'
  },
  locationText: {
    marginTop: '1px'
  }
});
